<template>
    <secition-card
        title="지원자 지역"
        v-bind="{
            loading,
        }"
        class="fill-height"
    >
        <v-data-table
            v-bind="{
                headers,
                items,
                'items-per-page': -1,
                'mobile-breakpoint': -1,
            }"
            hide-default-footer
            disable-filtering
            disable-pagination
            disable-sort
            dense
        >
            <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
        </v-data-table>
    </secition-card>
</template>

<script>
import api from "@/api";
import { APPLICATION_STATES } from "@/assets/variables";

import SecitionCard from "@/components/console/dumb/secition-card.vue";

export default {
    components: {
        SecitionCard,
    },
    props: {
        _recruitment: { type: String, default: undefined },
        searchDateValue: { type: Array, default: () => [null, null] },
    },
    data: () => ({
        statistics: [],

        loading: false,
    }),
    computed: {
        headers() {
            return [
                {
                    text: "지역",
                    value: "_id",
                    formatter: (value) => value || "미기재",
                },
                {
                    text: "지원자수",
                    value: "count",
                    width: 80,
                    align: "end",
                    formatter: (value) => `${value?.format?.() || 0}명`,
                },
            ].map((item) => ({ ...item, cellClass: `${item.cellClass || ""} text-caption` }));
        },
        items() {
            return this.statistics;
        },
    },
    methods: {
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { _recruitment, searchDateValue } = this;
                const { statistics } = await api.console.recruitments.applications.gets({
                    _recruitment,
                    headers: { limit: 5, mode: "residence-statistics" },
                    params: {
                        state: JSON.stringify({ $nin: [APPLICATION_STATES.ON_WRITING.value] }),
                        searchDateValue,
                    },
                });
                this.statistics = statistics;
            } finally {
                this.loading = false;
                this.$emit("updated");
            }
        },
    },
    watch: {
        searchDateValue() {
            this.search();
        },
    },
    mounted() {
        this.search();
    },
};
</script>

<style>
</style>